/**
 * Enumerates all possible navigation keys in the app. Is used for permissions.
 * Each route has an associated value in this enum.
 * Note: /users and /users?id=1 are both the same route.
 */

export class NavKeys {
  static Home = 'home';
  static Users = 'users';
  static Groups = 'groups';
}
